import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=3c04e4c8&scoped=true&"
import script from "./tab3.vue?vue&type=script&lang=js&"
export * from "./tab3.vue?vue&type=script&lang=js&"
import style0 from "./tab3.vue?vue&type=style&index=0&id=3c04e4c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04e4c8",
  null
  
)

export default component.exports